import { cn, Icon, type SvgIcon } from '@bridebook/aura';
import { useFieldContext } from './field';

export type FieldLabelProps = React.ComponentPropsWithoutRef<'label'> & {
  icon?: SvgIcon;
  iconRight?: SvgIcon;
  children?: React.ReactNode;
};

export const FieldLabel = ({ className, icon, iconRight, children, ...props }: FieldLabelProps) => {
  const context = useFieldContext();
  const isError = context?.error ?? false;

  return (
    <label
      className={cn(
        'flex h-5 items-center gap-1 typo-sm-semibold',
        isError ? 'text-errors' : 'text-space',
        className,
      )}
      {...props}>
      {icon && <Icon icon={icon} size={16} className={isError ? 'text-errors' : 'text-space'} />}
      {children}
      {iconRight && <Icon icon={iconRight} size={16} className="text-space" />}
    </label>
  );
};

FieldLabel.displayName = 'FieldLabel';
